<template>
    <div class="padding-10px">
        <el-card class="box-card" shadow="none" style="min-height: 500px;">
            <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
                <el-row :gutter="5">
                    <el-col :span="5">
                        <el-input size="medium" placeholder="搜索关键字: 渠道、标题" v-model="key" style="width: 97%;"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-select size="medium" placeholder="状态" v-model="searchStatusSelect" clearable>
                            <el-option label="未开始" value="0" key="0"></el-option>
                            <el-option label="进行中" value="1" key="1"></el-option>
                            <el-option label="已结束" value="2" key="2"></el-option>
                            <el-option label="已禁用" value="3" key="3"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6">
                        <el-date-picker v-model="createTime" type="datetimerange" size="medium" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" :editable="true" :clearable="true">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="3">
                        &nbsp;
                    </el-col>
                    <el-col :span="2">
                        <el-button size="medium" type="primary" @click="searchPoster"
                            icon="el-icon-search">搜索</el-button>
                    </el-col>
                    <el-col :span="2">
                        &nbsp;
                    </el-col>
                    <el-col :span="4">
                        &nbsp;
                        <el-button size="medium" type="success" @click="openDialog('add', null)">新增海报</el-button>
                    </el-col>
                </el-row>
            </div>
            <div>
                <el-table :data="tableData" border fixed min-height="400" style="width: 100%">
                    <el-table-column prop="sort" label="排序" min-width="40" />
                    <el-table-column prop="title" label="标题" min-width="100" />
                    <el-table-column prop="posterImage" label="缩略图" min-width="80">
                        <template slot-scope="scope">
                            <img :src="scope.row.thumbnail" min-width="32" height="32" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="channelId" label="渠道" min-width="90">
                        <template slot-scope="scope" v-if="scope.row.channels">
                            <!--              <el-tooltip slot="title" class="item span_hover" effect="light" :content="scope.row.channels + '。'" placement="top">-->
                            <!--              </el-tooltip>-->
                            <span v-for="posterChannel in scope.row.channels"
                                v-html="posterChannel.channelName + '、'" />
                        </template>
                    </el-table-column>
                    <!--          <el-table-column prop="channelId" label="渠道区域" min-width="90">-->
                    <!--            <template slot-scope="scope" v-if="scope.row.regionals">-->
                    <!--              &lt;!&ndash;              <el-tooltip slot="title" class="item span_hover" effect="light" :content="scope.row.channels + '。'" placement="top">&ndash;&gt;-->
                    <!--              &lt;!&ndash;              </el-tooltip>&ndash;&gt;-->
                    <!--              <span v-for="posterRegional in scope.row.regionals" v-html="posterRegional + '、'"/>-->
                    <!--            </template>-->
                    <!--          </el-table-column>-->
                    <el-table-column prop="posterImage" label="海报图片" min-width="80">
                        <template slot-scope="scope">
                            <img :src="scope.row.posterImage" min-width="32" height="64" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="60">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0">未开始</span>
                            <span v-else-if="scope.row.status == 1">进行中</span>
                            <span v-else-if="scope.row.status == 2">已结束</span>
                            <span v-else-if="scope.row.status == 3">已禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startTime" label="开始时间" min-width="90" />
                    <el-table-column prop="endTime" label="结束时间" min-width="90" />
                    <el-table-column prop="createTime" label="生成时间" min-width="90" />

                    <el-table-column label="操作" min-width="145" fixed="right">
                        <template slot-scope="scope">
                            <div class="button-container">
                                <el-button
                                    v-if="scope.row.status == 3 && checkButtonPermission('popularize:manage:poster:enable')"
                                    @click="posterOperation(scope.row.posterId, 1)" type="success" size="mini">启用
                                </el-button>
                                <el-button
                                    v-else-if="scope.row.status == 1 && checkButtonPermission('popularize:manage:poster:enable')"
                                    @click="posterOperation(scope.row.posterId, 3)" type="danger" size="mini">禁用
                                </el-button>
                                <el-button
                                    v-if="(scope.row.status == 1 || scope.row.status == 3) && checkButtonPermission('popularize:manage:poster:end')"
                                    @click="posterOperation(scope.row.posterId, 2)" type="danger" size="mini">结束
                                </el-button>
                                <el-button
                                    v-else-if="(scope.row.status == 0 || scope.row.status == 2) && checkButtonPermission('popularize:manage:poster:end')"
                                    @click="posterOperation(scope.row.posterId, 1)" type="success" size="mini">开启
                                </el-button>
                                <el-button
                                    v-if="scope.row.visible == 0 && checkButtonPermission('popularize:manage:poster:visible')"
                                    @click="updatePosterVisible(scope.row.posterId, 1)" type="success" size="mini">显示
                                </el-button>
                                <el-button
                                    v-else-if="scope.row.visible == 1 && checkButtonPermission('popularize:manage:poster:visible')"
                                    @click="updatePosterVisible(scope.row.posterId, 0)" type="danger" size="mini">隐藏
                                </el-button>
                                <el-button size="mini" @click="openDialog('edit', scope.row)"
                                    v-if="checkButtonPermission('popularize:manage:poster:edit')">编辑</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin: 18px 0px; float: right;">
                    <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
                        :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize"
                        :page-count="totalPage" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog :visible.sync="dialogVisible" @closed="resetForm('posterForm')" :title="dialogTitle + '海报'"
            :modal="false" :close-on-click-modal="false">
            <el-form :model="posterForm" ref="posterForm" :rules="posterFormRules" label-width="140px" size="medium"
                style="padding: 0 10%;">
                <el-form-item label="渠道" prop="channelId">
                    <el-select v-model="selectedChannels" @change="show(channels)" multiple placeholder="请选择渠道">
                        <el-option v-for="channel in channels" :key="channel.channelId" :label="channel.channelName"
                            :value="channel.channelId">
                        </el-option>
                    </el-select>
                    <el-select v-model="selectedSubBranchs" :disabled="subBranchStatus" multiple placeholder="请选择区域">
                        <el-option v-for="subBranch in subBranchs" :key="subBranch" :label="subBranch"
                            :value="subBranch">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number clearable v-model="posterForm.sort" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="posterForm.title"></el-input>
                </el-form-item>
                <el-form-item label="推广开始时间" prop="startTime">
                    <el-date-picker v-model="posterForm.startTime" clearable format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="推广结束时间" prop="endTime">
                    <el-date-picker v-model="posterForm.endTime" type="date" clearable format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" align="right" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="报名二维码水平位置" prop="originLefts">
                    <el-input-number clearable v-model="posterForm.originLefts"></el-input-number>
                </el-form-item>
                <el-form-item style="margin-top: -20px; color: red; line-height: 10px;">
                    <div style="line-height: 20px;">说明：值为0时，二维码水平方向的位置为居中。大于0时右移动，小于0时左移动。</div>
                    <div style="line-height: 20px;">推荐默认：-250</div>
                </el-form-item>
                <el-form-item label="报名二维码竖直位置" prop="originTops">
                    <el-input-number clearable v-model="posterForm.originTops"></el-input-number>
                </el-form-item>
                <el-form-item style="margin-top: -20px; color: red;">
                    <div style="line-height: 20px;">说明：值为0时，二维码竖直方向的位置为居中。大于0时下移动，小于0时上移动。</div>
                    <div style="line-height: 20px;">推荐默认：900</div>
                </el-form-item>
                <el-form-item label="海报图片" prop="posterImage">
                    <el-upload :class="{ hide: hidePoster }" :limit="posterLimit" :file-list="fileList"
                        :action="this.env.env.uploadUrl" list-type="picture-card" :on-success="uploadPosterSuccess"
                        :on-preview="uploadPreviewHandler" :on-remove="uploadRemoveHandler">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="缩略图" prop="thumbnail">
                    <el-upload :class="{ hide: hideThumbnail }" :limit="thumbnailLimit" :file-list="thumbnailFileList"
                        :action="this.env.env.uploadUrl" list-type="picture-card" :on-success="uploadThumbnailSuccess"
                        :on-preview="uploadThumbnailPreviewHandler" :on-remove="uploadThumbnailRemoveHandler">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="二维码的文章" prop="writingsId">
                    <el-select v-model="posterForm.writingsId" placeholder="请选择二维码文章" clearable>
                        <el-option v-for="channel in writings" :key="channel.writingsId" :label="channel.title"
                            :value="channel.writingsId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="二维码水平位置" prop="lefts" v-if="posterForm.writingsId">
                    <el-input-number clearable v-model="posterForm.lefts"></el-input-number>
                </el-form-item>
                <el-form-item style="margin-top: -20px; color: red; line-height: 10px;" v-if="posterForm.writingsId">
                    <div style="line-height: 20px;">说明：值为0时，二维码水平方向的位置为居中。大于0时右移动，小于0时左移动。</div>
                    <div style="line-height: 20px;">推荐默认：0</div>
                </el-form-item>
                <el-form-item label="二维码竖直位置" prop="tops" v-if="posterForm.writingsId">
                    <el-input-number clearable v-model="posterForm.tops"></el-input-number>
                </el-form-item>
                <el-form-item style="margin-top: -20px; color: red;" v-if="posterForm.writingsId">
                    <div style="line-height: 20px;">说明：值为0时，二维码竖直方向的位置为居中。大于0时下移动，小于0时上移动。</div>
                    <div style="line-height: 20px;">推荐默认：300</div>
                </el-form-item>
                <el-form-item size="large">
                    <el-button
                        @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
                    <el-button type="primary" :loading="loading"
                        @click="submitPosterForm('posterForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--<el-dialog :visible.sync="uploadDialogVisible">
      <img width="100%" :src="userForm.carCategoryImage" alt="">
    </el-dialog>-->
    </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
    name: "posterList",
    data() {
        return {
            key: '',
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            totalPage: 100,
            total: 100000,
            createTime: [],
            dialogType: 'add',
            dialogTitle: '新增',
            dialogVisible: false,
            posterForm: { sort: 1 },
            posterFormRules: {},
            selectedChannels: [],
            selectedSubBranchs: [],
            channels: [],
            writings: [],
            subBranchs: [],
            subBranchStatus: true,
            dialogOperation: '',
            hidePoster: false,
            posterLimit: 1,
            fileList: [],
            hideThumbnail: false,
            thumbnailLimit: 1,
            thumbnailFileList: [],
            loading: false,
            searchStatusSelect: '',
        }
    },
    created() {
        this.searchPoster();
    },
    methods: {
        uploadThumbnailSuccess(resp, file, list) {
            this.hideThumbnail = list.length >= this.thumbnailLimit;
            if (reqCode.SUCCESS == resp.code) {
                this.posterForm.thumbnail = resp.data;
            } else {
                this.$message({
                    message: '上传缩略图失败：' + resp.message,
                    type: 'error'
                });
            }
        },
        uploadThumbnailPreviewHandler(file) {
            this.posterForm.thumbnail = file.url;
        },
        uploadThumbnailRemoveHandler(file, list) {
            this.hideThumbnail = list.length >= this.thumbnailLimit;
        },
        uploadRemoveHandler(file, list) {
            this.hidePoster = list.length >= this.registerLimit;
        },
        uploadPreviewHandler(file) {
            this.posterForm.posterImage = file.url;
        },
        uploadPosterSuccess(resp, file, list) {
            this.hidePoster = list.length >= this.posterLimit;
            if (reqCode.SUCCESS == resp.code) {
                this.posterForm.posterImage = resp.data;
            } else {
                this.$message({
                    message: '上传文件失败：' + resp.message,
                    type: 'error'
                });
            }
        },
        show(data) {
            console.log(data);
            this.subBranchStatus = this.checkSubBranchStatus();
            if (this.subBranchStatus) {
                this.selectedSubBranchs = [];
            }
        },
        checkSubBranchStatus() {
            let flag = true;
            this.selectedChannels.forEach((item, i) => {
                console.log("===" + item);
                if (item == 'de8941fd3cd148178f8068233e37aee1') {
                    flag = false;
                    console.log("================");
                }
            });
            return flag;
        },
        getWritings() {
            this.$http.post('/api/popularize/writings/search', {
                currentPage: 1,
                key: '',
                size: 1000
            }, {
                headers: {
                    accessToken: sessionStorage.getItem('accessToken')
                }
            }).then(resp => {
                let data = resp.data || {};
                this.writings = data.pageInfo ? data.pageInfo.list : [];
            }).catch(response => {
                this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                    confirmButtonText: '确定'
                });
            });
        },
        getChannels() {
            this.$http.post('/api/channel-service/channel/logged/all', {}, {
                headers: {
                    accessToken: sessionStorage.getItem('accessToken')
                }
            }).then(resp => {
                console.log(resp.data.resultList)
                let data = resp.data;
                this.channels = data.resultList;
            }).catch(response => {
                this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                    confirmButtonText: '确定'
                });
            });
        },
        getSubBranchs() {
            this.$http.get('/api/user/dotnode/getSubBranch', {
                headers: {
                    accessToken: sessionStorage.getItem('accessToken')
                }
            }).then(resp => {
                let data = resp.data;
                this.subBranchs = data.data;
            }).catch(response => {
                this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                    confirmButtonText: '确定'
                });
            });
        },
        searchPoster() {
            let reqParam = {
                key: this.key,
                size: this.pageSize,
                currentPage: this.currentPage,
                startCreateTime: this.createTime[0],
                endCreateTime: this.createTime[1],
            };

            if ('' != this.searchStatusSelect - 1 != this.searchStatusSelect) {
                reqParam.status = this.searchStatusSelect;
            }

            this.$http.post('/api/popularize-service/poster/search', reqParam, {
                headers: {
                    accessToken: sessionStorage.getItem('accessToken')
                }
            }).then(resp => {
                console.log(resp);
                let data = resp.data;
                if ("success" === data.code) {
                    let pageInfo = data.pageInfo;
                    this.tableData = pageInfo.list;
                    this.pageSize = pageInfo.pageSize;
                    this.total = pageInfo.total;
                    this.totalPage = pageInfo.pages;
                } else {
                    this.$alert('' + data.message, '温馨提示', {
                        confirmButtonText: '确定'
                    });
                }
            }).catch(response => {
                this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                    confirmButtonText: '确定'
                });
            })
        },
        addPoster(formName, reqParam) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.post('/api/popularize-service/poster/add', reqParam, {
                        headers: {
                            accessToken: sessionStorage.getItem('accessToken')
                        }
                    }).then(resp => {
                        this.loading = false
                        let data = resp.data;
                        if (data.code) {
                            this.searchPoster();
                            this.$message({
                                message: '新增海报成功',
                                type: 'success'
                            });
                            this.dialogVisible = false;
                            this.resetForm('posterForm');
                        } else {
                            this.$alert('' + data.message, '错误提示', {
                                confirmButtonText: '确定',
                            });
                        }
                    }).catch(e => {
                        this.$alert('' + e, '错误提示', {
                            confirmButtonText: '确定',
                        });
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        updatePoster(formName, reqParam) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.post('/api/popularize-service/poster/update', reqParam, {
                        headers: {
                            accessToken: sessionStorage.getItem('accessToken')
                        }
                    }).then(resp => {
                        this.loading = false
                        let data = resp.data;
                        if (data.code) {
                            this.searchPoster();
                            this.$message({
                                message: '编辑海报成功',
                                type: 'success'
                            });
                            this.dialogVisible = false;
                            this.resetForm('posterForm');
                        } else {
                            this.$alert('' + data.message, '错误提示', {
                                confirmButtonText: '确定',
                            });
                        }
                    }).catch(e => {
                        this.$alert('' + e, '错误提示', {
                            confirmButtonText: '确定',
                        });
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        posterOperation(posterId, status) {
            let reqParam = {
                posterId: posterId,
                status: status,
            };
            this.$http.post('/api/popularize-service/poster/operation', reqParam, {
                headers: {
                    accessToken: sessionStorage.getItem('accessToken')
                }
            }).then(resp => {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.searchPoster();
            }).catch(response => {
                this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                    confirmButtonText: '确定'
                });
            })
        },
        updatePosterVisible(posterId, visible) {
            let reqParam = {
                posterId: posterId,
                visible: visible,
            };
            this.$http.post('/api/popularize-service/poster/updateVisible', reqParam, {
                headers: {
                    accessToken: sessionStorage.getItem('accessToken')
                }
            }).then(resp => {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.searchPoster();
            }).catch(response => {
                this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                    confirmButtonText: '确定'
                });
            })
        },
        deletePoster(posterId) {
            this.$confirm('此操作将永久该海报, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/popularize-service/poster/delete?posterId=' + posterId, {}, {
                    headers: {
                        accessToken: sessionStorage.getItem('accessToken')
                    }
                }).then(resp => {
                    let data = resp.data;
                    if (data.code === "success") {
                        this.dialogVisible = false;
                        this.$message({
                            message: '删除海报成功',
                            type: 'success'
                        });
                        this.searchPoster();
                    } else {
                        this.$alert('' + data.message, '温馨提示', {
                            confirmButtonText: '确定'
                        });
                    }
                }).catch(e => {
                    this.$alert('' + e, '温馨提示', {
                        confirmButtonText: '确定'
                    });
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        currentPageChange(val) {
            this.currentPage = val;
            this.searchPoster();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.searchPoster();
        },
        openDialog(dialogType, data) {
            this.dialogOperation = dialogType;
            if (dialogAction.ADD == dialogType) {
                this.dialogTitle = "新增"
                this.getChannels();
                this.getWritings();
                this.getSubBranchs();
                this.posterForm = { originLefts: -250, originTops: 900, lefts: 0, tops: 300 };
            } else if (dialogAction.EDIT == dialogType) {
                this.dialogTitle = "编辑"
                this.getChannels();
                this.getWritings();
                this.getSubBranchs();
                this.posterForm = JSON.parse(JSON.stringify(data));
                this.fileList.push({
                    "url": data.posterImage,
                    "name": '',
                    "id": ''
                })
                this.thumbnailFileList.push({
                    "url": data.thumbnail,
                    "name": '',
                    "id": ''
                })
                for (var o in data.channels) {
                    this.selectedChannels.push(data.channels[o].channelId)
                }
                this.subBranchStatus = this.checkSubBranchStatus();
                for (var r in data.regionals) {
                    this.selectedSubBranchs.push(data.regionals[r])
                }
            }

            this.dialogVisible = true;
        },
        submitPosterForm(formName) {
            this.loading = true
            let reqParam = {
                posterImage: this.posterForm.posterImage,
                title: this.posterForm.title,
                originLefts: this.posterForm.originLefts,
                originTops: this.posterForm.originTops,
                startTime: this.posterForm.startTime,
                endTime: this.posterForm.endTime,
                channels: this.selectedChannels,
                thumbnail: this.posterForm.thumbnail,
                sort: this.posterForm.sort,
                writingsId: this.posterForm.writingsId,
                lefts: this.posterForm.lefts,
                tops: this.posterForm.tops,
                regionals: this.selectedSubBranchs
            };

            if (dialogAction.ADD == this.dialogOperation) {
                this.addPoster(formName, reqParam);
            } else if (dialogAction.EDIT == this.dialogOperation) {
                reqParam.posterId = this.posterForm.posterId;
                console.log(reqParam)
                this.updatePoster(formName, reqParam);
            }
        },
        resetForm(formName) {
            this.$nextTick(() => {
                this.createTime = [];
                this.posterForm = { sort: 1 };
                this.fileList = [];
                this.thumbnailFileList = [];
                this.selectedChannels = [];
                this.selectedSubBranchs = [];
                this.$refs[formName].resetFields();
            })
        },
        checkButtonPermission(perms) {
            let menuPermsList = sessionStorage.getItem("menuPermsList");
            if (menuPermsList.indexOf(perms) != -1) {
                return true
            } else {
                return false;
            }
        }
    },
    watch: {
        createTime(newCeateTime, oldCeateTime) {
            if (null == newCeateTime || undefined == newCeateTime) {
                this.createTime = [];
            }
        }
    }
}
</script>

<style>
.hide .el-upload--picture-card {
    display: none;
}

.span_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    height: 24px;
    display: block;
}

.span_hover:hover {
    cursor: pointer;
}

.button-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.button-container .el-button {
    margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/popularize/poster/posterList.vue